var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'title-widget text-body-1 text-uppercase font-weight-bold',
    _vm.noDecoration && 'title-widget-no-decoration',
    _vm.dark && 'title-widget-dark' ]},[_c('div',{class:[
      'title-widget-text roboto-condensed px-4 py-1',
      _vm.dark ? 'white' : 'white--text secondary' ]},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }